module.exports = __webpack_public_path__ + "img/UrbanMining@2x.37bfe4d.webp";